import { SlashCommand } from './types';
import { systemCommands } from './system-commands';
import { builtInCommands } from './built-in-commands';
import { aiToolsCommands } from './ai-tools-commands';
import { hubCommands } from './hub-commands';
import { justLyricsCommands } from './justlyrics-commands';
import { dictionaryCommands } from './dictionary-commands';
import { askFliptCommands } from './askflipt-commands';
import { exportYtCommands } from './exportyt-commands';
import { scenereaderCommands } from './scenereader-commands';
import { pdfToolsCommands } from './pdf-tools-commands';
import { justRecordCommands } from './justrecord-commands';
import { tiktokArchiverCommands } from './tiktok-archiver-commands';
import { justRemoveCommands } from './justremove-commands';
import { diaryCommands } from './diary-commands';
import { firaqCommands } from './firaq-commands';
import { steganoCommands } from './stegano-commands';

export * from './types';

export const COMMAND_REGISTRY: SlashCommand[] = [
    ...systemCommands,
    ...builtInCommands,
    ...aiToolsCommands,
    ...hubCommands,
    ...justLyricsCommands,
    ...dictionaryCommands,
    ...askFliptCommands,
    ...exportYtCommands,
    ...scenereaderCommands,
    ...pdfToolsCommands,
    ...justRecordCommands,
    ...tiktokArchiverCommands,
    ...justRemoveCommands,
    ...diaryCommands,
    ...firaqCommands,
    ...steganoCommands
];

export function parseSlashCommand(input: string): { command: SlashCommand | null; content: string } {
    if (!input.startsWith('/')) return { command: null, content: input };

    const firstSpaceIdx = input.indexOf(' ');
    const triggerEnd = firstSpaceIdx === -1 ? input.length : firstSpaceIdx;
    const triggerToken = input.substring(0, triggerEnd).toLowerCase();

    const matchedCommand = COMMAND_REGISTRY.find(cmd => cmd.trigger.toLowerCase() === triggerToken);
    
    if (matchedCommand) {
        const content = firstSpaceIdx === -1 ? '' : input.substring(firstSpaceIdx + 1).trim();
        return { command: matchedCommand, content };
    }

    return { command: null, content: input };
}

export function filterSlashCommands(query: string): SlashCommand[] {
    const q = query.toLowerCase().replace('/', '');
    return COMMAND_REGISTRY.filter(cmd => 
        cmd.trigger.toLowerCase().includes(q) || 
        cmd.name.toLowerCase().includes(q) ||
        (cmd.integration && cmd.integration.toLowerCase().includes(q))
    );
}
